import { apiFetch } from './client';
import type { SubscriptionPlan } from '../types/mjai';

export async function getPlans(): Promise<{ plans: SubscriptionPlan[] }> {
  return apiFetch('/subscriptions/plans');
}

export async function createCheckout(tier: string): Promise<{ checkout_url: string; session_id: string }> {
  return apiFetch(`/subscriptions/create-checkout?tier=${tier}`, { method: 'POST' });
}

export async function createPortalSession(): Promise<{ portal_url: string }> {
  return apiFetch('/subscriptions/portal', { method: 'POST' });
}
